/**
 * Parses a route/query param into a positive integer id.
 * Returns null for missing, non-numeric, NaN, or non-positive values.
 */
export function parsePositiveInt(value: string | undefined): number | null {
    if (value == null || value === '') {
        return null;
    }
    const parsed = /^\d+$/.test(value) ? Number.parseInt(value, 10) : Number.NaN;
    if (!Number.isSafeInteger(parsed) || parsed <= 0) {
        return null;
    }
    return parsed;
}

export function isValidPositiveInt(value: number): boolean {
    return Number.isSafeInteger(value) && value > 0;
}
